require('./bootstrap');

window.Vue = require('vue').default;

Vue.component('delivery-component', require('./components/DeliveryComponent.vue').default);
Vue.component('edit-order-map-component', require('./components/EditOrderMapComponent.vue').default);
Vue.component('view-order-map-component', require('./components/ViewOrderMapComponent.vue').default);
Vue.component('product-image-component', require('./components/ProductImageComponent.vue').default);
Vue.component('cart-component', require('./components/CartComponent.vue').default);
Vue.component('add-to-cart-component', require('./components/AddToCartComponent.vue').default);

window.EventBus = new Vue();

const app = new Vue({
    el: '.app'
});

require('./theme/carousel')
require('./theme/checkout')
require('./theme/scroll-top-button')
require('./theme/smooth-scroll')
require('./theme/offcanvas')
require('./theme/password-visibility-toggle')
require('./theme/phoneNumbers')
require('./components/datapickers')
